import { ChangeDetectorRef, Component, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { CostCenterPriceService } from 'src/app/services/archive/cost-center-price.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { PriceListDetailService } from 'src/app/services/archive/price-list-detail.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-cost-center-price',
  templateUrl: './register-cost-center-price.component.html',
  styleUrls: ['./register-cost-center-price.component.scss'],
  standalone: false
})
export class RegisterCostCenterPriceComponent implements OnInit {

  @ViewChild('selectArticle') articleModalComponent?: CustomModalComponent | null = null;

  ascendantArticle: boolean = true;
  blockForm: boolean = false;
  branchId: number = 0;
  codeNameClient: string = '';
  codeNameConstructionSite: string = '';
  columnSortArticle: string | null = null;
  component = CustomTableSelectComponent;
  costCenterContract: CostCenterModel = new CostCenterModel();
  costCenterId: number = 0;
  costCenterPriceModel: CostCenterPriceModel = new CostCenterPriceModel();
  dataArticle: PagedResponseModel<ArticleSelectionTableModel> =
    new PagedResponseModel<ArticleSelectionTableModel>();
  discountValue: number = 0;
  filtersArticle: ColumnResponseModel[] = [];
  formCostCenterPrice: FormGroup = new FormGroup({});
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelect$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
    actions: []
  });
  limitArticle: number = 5;
  listArticles: any[] = [];
  listBranches: CustomListDropdown[] = [];
  listConcepts: any[] = [];
  listCostCenters: CustomListDropdown[] = [];
  listInvoiceUnits: CustomListDropdown[] = [
    { value: false, label: 'UNIDAD' },
    { value: true, label: 'M2' }
  ];
  listRentalUnits: CustomListDropdown[] = [];
  loading: boolean = false;
  nameRentalUnit: string = '';
  openFrom: string = '';
  output$ = new Subject<any>();
  pageArticle: number = 1;
  permissionUpdatable: boolean = false;
  rentalUnitId: number = 0;
  subscription: Subscription;
  subscriptions: Subscription[] = [];
  swFacturacionEspecial: boolean = false;
  swIsInvoiced: boolean = false;

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private cdr: ChangeDetectorRef,
    public config: DynamicDialogConfig,
    private confirmDialogService: ConfirmDialogService,
    private costCenterPriceService: CostCenterPriceService,
    private costCenterService: CostCenterService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private priceListDetailService: PriceListDetailService,
    private toastHandlerService: ToastHandlerService,
    private windowService: WindowService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm(new CostCenterPriceModel());
  }

  async ngOnInit() {
    this.subscriptions.push(
      this.output$.subscribe(({ type, payload }) => {
        switch (type) {
          case 'onPageChange':
            this.onPageChangeArticle(payload);
            break;
          case 'onFilterChange':
            this.onFilterChange(payload);
            break;
          default:
            console.warn('Tipo de evento desconocido:', type);
        }
      })
    );

    const input$ = this.config.data?.inputs$;
    if (!input$) { return; }
    this.subscriptions.push(input$.subscribe(async (inputs: any) => {
      const { blockForm, costCenterPriceModel, openFrom } = inputs;
      this.costCenterPriceModel = costCenterPriceModel;
      this.blockForm = blockForm;
      this.openFrom = openFrom;
    }));
    this.loading = true;
    await this.getPermission();
    await this.handleOpenModal();
    setTimeout(() => this.loading = false, 300);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  branchIdControl(costCenterPrice?: CostCenterPriceModel): number {
    if (costCenterPrice?.costCenter?.branchId) {
      return costCenterPrice.costCenter.branchId;
    }
    return this.branchId;
  }

  changeConceptInvoicing(conceptInvoicingId: number) {
    const costCenterId = this.formCostCenterPrice.get('costCenterId')?.value;
    const model = new CostCenterPriceModel();
    model.costCenterId = costCenterId;
    model.conceptInvoicingId = conceptInvoicingId;
    model.costCenter = this.costCenterPriceModel.costCenter;
    this.costCenterPriceModel = model;

    this.getArticleById(null);
    this.validateForm(this.costCenterPriceModel);
    this.updateDiscountAndUnitValue(0, 0, 0);
  }

  async changeArticle(selectedItems: any[], articleIdSelected?: number) {
    const articleId = articleIdSelected ? articleIdSelected : selectedItems[0]?.articleId;
    if (articleId) {
      const priceListId = this.costCenterPriceModel.costCenter.priceListId;
      const response = await this.getClientUnitValueByPriceListArticle(priceListId, articleId);
      if (response) {
        this.costCenterPriceModel.articleId = articleId;
        await Promise.all([
          this.getCostCenterPriceByKeys(),
          this.getArticleById(articleId)
        ]);
        const { baseUnitValue, rateDiscount, unitValue } = this.costCenterPriceModel;
        this.validateForm(this.costCenterPriceModel);
        this.updateDiscountAndUnitValue(baseUnitValue, rateDiscount, unitValue);
      } else {
        this.costCenterPriceModel.articleId = 0;
        this.updateDiscountAndUnitValue(0, 0, 0);
        this.validateForm(this.costCenterPriceModel);
      }
    }
  }

  async changeInvoiceUnit() {
    const swInvoiceUnitM2 = this.formCostCenterPrice.get("swInvoiceUnitM2")?.value;
    const costCenterId = this.formCostCenterPrice.get("costCenterId")?.value;
    const articleId = this.formCostCenterPrice.get("articleId")?.value;
    if (costCenterId != null && costCenterId != 0 && articleId != null && articleId != 0) {
      if (!swInvoiceUnitM2) {
        //Si es UND validar si el valor base fue modificado en la lista de precio del cco.
        const priceListId = this.costCenterPriceModel.costCenter.priceListId;
        const response = await this.getClientUnitValueByPriceListArticle(priceListId, articleId);
        const rateDiscount = this.costCenterPriceModel.rateDiscount;
        this.updateDiscountAndUnitValue(response, rateDiscount, 0);
      } else {
        //Busca el valor del m2 del cco seleccionado
        await this.getBaseUnitValueByKeys(costCenterId, articleId, swInvoiceUnitM2);
      }
    }
  }

  async changeSwIsInvoiced(swIsInvoiced: boolean) {
    if (!swIsInvoiced) {
      this.discountValue = 0;
      this.formCostCenterPrice.patchValue({
        baseUnitValue: 0,
        unitValue: 0,
        rateDiscount: 0,
        swIsInvoiced
      });
      return;
    }

    if (!this.costCenterPriceModel.articleId || !this.costCenterPriceModel.costCenterId) {
      this.toastHandlerService.showToast(
        'warning',
        'Primero debe seleccionar el artículo y el centro de costos.'
      );
      return;
    }

    await this.changeInvoiceUnit();
  }

  changeRateDiscount(currentRateDiscount: number) {
    const baseUnitValue = this.formCostCenterPrice.get("baseUnitValue")?.value;
    const previusRateDiscount = this.costCenterPriceModel.rateDiscount;
    if (baseUnitValue == 0 || currentRateDiscount == null) {
      this.formCostCenterPrice.controls["rateDiscount"].setValue(0);
      return;
    }

    if (previusRateDiscount == 0 || (currentRateDiscount != previusRateDiscount)) {
      this.discountValue = (baseUnitValue * currentRateDiscount) / 100;
      const unitValue = baseUnitValue * (1 - currentRateDiscount / 100);
      this.formCostCenterPrice.controls["unitValue"].patchValue(unitValue);

    }
    this.costCenterPriceModel.rateDiscount = currentRateDiscount;
  }

  changeUnitValue(unitValue: number) {
    const baseUnitValue = this.formCostCenterPrice.get("baseUnitValue")?.value ?? 0;
    if (baseUnitValue <= 0) {
      this.discountValue = 0;
      this.formCostCenterPrice.controls["rateDiscount"].patchValue(0);
      return;
    }

    const rateDiscount = Number((((baseUnitValue - unitValue) / baseUnitValue) * 100).toFixed(5));
    this.costCenterPriceModel.rateDiscount = rateDiscount;
    this.discountValue = (baseUnitValue * rateDiscount) / 100;
    this.formCostCenterPrice.controls["rateDiscount"].patchValue(rateDiscount);
  }

  async changeCostCenter(costCenterId: number | null) {
    try {
      if (costCenterId) {
        await this.getCostCenterById(costCenterId);
        this.costCenterPriceModel = new CostCenterPriceModel();
        this.costCenterPriceModel.costCenterId = costCenterId;
        this.costCenterPriceModel.costCenter = this.costCenterContract;
        await this.getCostCenterData(costCenterId);
        this.validateForm(this.costCenterPriceModel);
      } else {
        this.resetContract();
      }
    } catch (error) {
      console.error('Error al cambiar de centro de costos.', error);
    }
  }

  close(reload: boolean) {
    const data: ModalObjectType = {};
    if (reload) {
      data.params = {
        reload: true,
        costCenterPriceModel: this.costCenterPriceModel
      };
    }
    this.resetContract();
    this.ref.close(data);
  }

  async fetchCostCenterPrice() {
    try {
      const { costCenter, costCenterId, articleId } = this.costCenterPriceModel;
      await Promise.all([
        this.getArticleById(articleId),
        this.getCostCenterData(costCenterId),
        this.getBranch(costCenter.branchId, false),
        this.validateAndUpdateClientUnitValue(this.costCenterPriceModel),
      ]);
      this.cdr.detectChanges();
      this.validateForm(this.costCenterPriceModel);
    } catch (error) {
      console.error('Error en el proceso de carga y validación del precio por centro de costos.', error);
    }
  }

  async getAllLists() {
    try {
      let costCenterId = 0;
      if (this.openFrom !== "createCostCenterPrice" && this.openFrom !== "editCostCenterPrice") {
        costCenterId = this.costCenterPriceModel.costCenterId;
      }
      const [articles, branches, concepts, units, costCenters] = await Promise.all([
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.costCenterPriceService.getAllConceptInvoicings(this.swFacturacionEspecial)),
        firstValueFrom(this.costCenterPriceService.getAllUnits()),
        firstValueFrom(this.costCenterPriceService.getAllCostCentersForSelectAsync(this.branchId, costCenterId)),
      ]);
      this.listArticles = articles;
      this.listBranches = branches;
      this.listConcepts = concepts;
      this.listRentalUnits = units;
      this.listCostCenters = costCenters;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getArticleById(articleId: number | null) {
    if (!articleId || articleId === 0) return;
    try {
      const response = await firstValueFrom(this.articleService.getArticleById(articleId));
      this.formCostCenterPrice.controls['articleId'].patchValue(response.articleId);
    } catch (error) {
      this.formCostCenterPrice.controls['articleId'].patchValue(0);
      console.error('Error al obtener el artículo por id.', error);
    }
  }

  async getArticlesForCostCenterPrice() {
    try {
      const response = await firstValueFrom(
        this.costCenterPriceService.getArticlesForCostCenterPrice(
          this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle
        )
      );
      this.dataArticle = response;
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de articulos.', error);
    }
  }

  async getBaseUnitValueByKeys(costCenterId: number, articleId: number, swInvoiceUnitM2: boolean) {
    try {
      const response = await firstValueFrom(
        this.costCenterPriceService.getBaseUnitValueByKeys(costCenterId, articleId, swInvoiceUnitM2)
      );
      const rateDiscount = this.costCenterPriceModel.rateDiscount;
      this.updateDiscountAndUnitValue(response, rateDiscount, 0);
    } catch (error) {
      console.error('Error al obtener el valor base.', error);
    }
  }

  async getBranch(branchId: number | null, change: boolean) {
    if (branchId && branchId != 0) {
      this.branchId = branchId;
      await this.getAllLists();
      if (change) {
        this.resetContract();
      }
    } else {
      this.branchId = 0;
    }
  }

  async getCostCenterById(costCenterId: number) {
    try {
      this.costCenterContract = await firstValueFrom(this.costCenterService.getCostCenterById(costCenterId));
    } catch (error) {
      console.error('Error al cargar el centro de costos:', error);
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length === 0) {
        this.headerArticle = await firstValueFrom(this.costCenterPriceService.getColumnsForArticle());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getCostCenterData(costCenterId: number | null) {
    try {
      let costCenter = null;
      if (costCenterId && costCenterId !== 0) {
        costCenter = await firstValueFrom(this.costCenterPriceService.getCostCenterById(costCenterId));
      }
      this.getClientName(costCenter);
      this.getConstructionSiteName(costCenter);
    } catch (error) {
      console.error('Error al obtener la informacion del centro de costos.', error);
    }
  }

  private getClientName(costCenter: any) {
    if (costCenter) {
      this.codeNameClient = `${costCenter.clientDocument} - ${costCenter.clientBusinessName}`;
    } else {
      this.codeNameClient = '';
    }
  }

  private getConstructionSiteName(costCenter: any) {
    if (costCenter) {
      this.codeNameConstructionSite = `${costCenter.constructionSiteCode} - ${costCenter.constructionSiteName}`;
    } else {
      this.codeNameConstructionSite = '';
    }
  }

  async getCostCenterPriceByKeys() {
    try {
      const { costCenterId, conceptInvoicingId, articleId } = this.costCenterPriceModel;
      const response = await firstValueFrom(this.costCenterPriceService.getCostCenterPriceByKeys(costCenterId,
        conceptInvoicingId, articleId));
      this.costCenterPriceModel = response;
    } catch (error) {
      console.error('Error al obtener el precio por centro de costos con claves.', error);
    }
  }

  async getClientUnitValueByPriceListArticle(priceListId: number, articleId: number) {
    try {
      return await firstValueFrom(this.priceListDetailService.getClientUnitValueByPriceListArticle(priceListId, articleId));;
    } catch (error) {
      console.error('Error al consultar el valor del artículo en la lista de precios.', error);
      return 0;
    }
  }

  async validateAndUpdateClientUnitValue(costCenterPriceModel: CostCenterPriceModel) {
    const { swInvoiceUnitM2, baseUnitValue, unitValue, rateDiscount, articleId, costCenter } = costCenterPriceModel;
    let finalBaseValue = baseUnitValue;
    let finalRateDiscount = rateDiscount;
    let finalUnitValue = unitValue;
    if (!swInvoiceUnitM2) {
      const priceListId = costCenter.priceListId;
      const newBaseValue = await this.getClientUnitValueByPriceListArticle(priceListId, articleId);
      if (baseUnitValue !== newBaseValue) {
        if (await this.confirmDialogService.confirm(
          `El precio base de este artículo fue modificado en la lista de precios del Centro de Costos.
          ¿Desea recalcular los precios? Nuevo precio base: ${newBaseValue}`
        )) {
          finalBaseValue = newBaseValue;
          finalRateDiscount = rateDiscount;
          finalUnitValue = 0;
        }
      }
    }

    this.updateDiscountAndUnitValue(finalBaseValue, finalRateDiscount, finalUnitValue);
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      await this.getBranch(response.branchId, true);
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario autenticado.', error);
    }
  }

  async getPermission() {
    await Promise.all([
      this.getPermissionProfileByUrl(),
      this.getSwFacturacionEspecial()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(
        this.windowService.getPermissionProfileByUrl('cost-center-price')
      );
    } catch (error) {
      console.error('Error al cargar permisos.', error);
    }
  }

  async getSwFacturacionEspecial() {
    try {
      this.swFacturacionEspecial = await firstValueFrom(this.costCenterPriceService.getSwFacturacionEspecial());
    } catch (error) {
      console.error('Error al obtener swFacturacionEspecial.', error);
    }
  }

  async handleCreateCostCenterPrice() {
    try {
      const costCenter = this.costCenterPriceModel.costCenter;
      if (costCenter.costCenterId) {
        await Promise.all([
          this.getBranch(this.costCenterPriceModel.costCenter.branchId, false),
          this.getCostCenterData(this.costCenterPriceModel.costCenterId)
        ]);
        this.cdr.detectChanges();
        this.validateForm(this.costCenterPriceModel);
      } else {
        await this.getFirstBranchByUserAuthenticatedAsync();
      }
    } catch (error) {
      console.error('Error al preparar los datos para crear un precio por centro de costos.', error);
    }
  }

  async handleEditCostCenterPrice() {
    try {
      if (this.costCenterPriceModel.costCenterPriceId === 0) {
        await this.getCostCenterPriceByKeys();
      }
      await this.fetchCostCenterPrice();
    } catch (error) {
      console.error('Error al cargar datos para editar el precio por centro de costos.', error);
    }
  }

  async handleOpenModal() {
    try {
      if (this.openFrom === 'createCostCenterPrice') {
        await this.handleCreateCostCenterPrice();
      } else {
        await this.handleEditCostCenterPrice();
      }
    } catch (error) {
      console.error('Error al procesar los datos del modal para creación o edición.', error);
    }
  }

  onReloadEmit() {
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'onReload', payload: true });
  }

  async openArticleModal() {
    const costCenterId = this.formCostCenterPrice.get("costCenterId")?.value;
    const conceptInvoicingId = this.formCostCenterPrice.get("conceptInvoicingId")?.value;
    if (costCenterId == null || costCenterId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Primero debe seleccionar el centro de costos.'
      );
      return
    }
    if (conceptInvoicingId == null || conceptInvoicingId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Primero debe seleccionar el concepto de facturación.'
      );
      return
    }
    if (this.openFrom !== "createCostCenterPrice" && this.openFrom !== "editCostCenterPrice") {
      this.toastHandlerService.showToast(
        'warning',
        'No está permitido modificar este artículo.'
      );
      return
    }

    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getArticlesForCostCenterPrice()
    ]);

    this.updateInputs();
    this.articleModalComponent?.show();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getArticlesForCostCenterPrice();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    this.validateFormControls();
    if (!this.formCostCenterPrice.valid) {
      this.showValidationMessages();
      return;
    }

    const modelCostCenterPrice = this.formCostCenterPrice.getRawValue() as CostCenterPriceModel;
    let response: CostCenterPriceModel | null = null;
    if (this.costCenterPriceModel.costCenterPriceId === 0) {
      try {
        response = await firstValueFrom(
          this.costCenterPriceService.createCostCenterPrice(modelCostCenterPrice)
        );
        this.toastHandlerService.showToast(
          'success',
          'El precio por centro de costos fue creado exitosamente.'
        );
      } catch (error) {
        console.error('Error al crear el precio por centro de costos.', error);
      }
    } else {
      this.costCenterPriceModel.swIsInvoiced = modelCostCenterPrice.swIsInvoiced;
      this.costCenterPriceModel.swInvoiceUnitM2 = modelCostCenterPrice.swInvoiceUnitM2;
      this.costCenterPriceModel.baseUnitValue = modelCostCenterPrice.baseUnitValue;
      this.costCenterPriceModel.rateDiscount = modelCostCenterPrice.rateDiscount;
      this.costCenterPriceModel.unitValue = modelCostCenterPrice.unitValue;
      this.costCenterPriceModel.minimumQuantityService = modelCostCenterPrice.minimumQuantityService;
      this.costCenterPriceModel.quantityEspecialInvoicing = modelCostCenterPrice.quantityEspecialInvoicing;
      try {
        response = await firstValueFrom(
          this.costCenterPriceService.updateCostCenterPrice(this.costCenterPriceModel)
        );
        this.toastHandlerService.showToast(
          'success',
          'El precio por centro de costos fue modificado exitosamente.'
        );
      } catch (error) {
        console.error('Error al actualizar el precio por centro de costos.', error);
      }
    }
    if (response) {
      this.costCenterPriceModel = response;
      await this.getCostCenterById(response.costCenterId);
      this.costCenterPriceModel.costCenter = this.costCenterContract;
      if (this.openFrom == "createRemissionDetail" || this.openFrom == "editRemissionDetail" ||
        this.openFrom == "createOrderDetail" || this.openFrom == "editOrderDetail" || this.openFrom == "editServiceDetail") {
        this.close(true);
      } else {
        this.onReloadEmit();
      }
      this.updateFormPermision();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.'
      },
      costCenterId: {
        required: 'El campo Centro de Costo es obligatorio.',
        min: 'Debe seleccionar un Centro de Costo válido.'
      },
      conceptInvoicingId: {
        required: 'El campo Concepto de Facturación es obligatorio.',
        min: 'Debe seleccionar un Concepto de Facturación válido.'
      },
      quantityEspecialInvoicing: {
        required: 'El campo Cantidad Facturación Especial es obligatorio.',
        min: 'Debe ingresar un valor igual o superior a Cero (0).',
        max: 'No puede ingresar un valor mayor a 9,999,999.99 en este campo.'
      },
      articleId: {
        required: 'El campo Artículo es obligatorio.',
        min: 'Debe seleccionar un Artículo válido.'
      },
      baseUnitValue: {
        required: 'El campo Valor Base Unitario es obligatorio.'
      },
      unitValue: {
        required: 'El campo Valor Unitario es obligatorio.',
        min: 'Debe ingresar un valor igual o superior a Cero (0).',
        max: 'No puede ingresar un valor mayor a 99,999,999,999.99 en este campo.'
      },
      rateDiscount: {
        required: 'El campo Descuento es obligatorio.',
        min: 'No puede ingresar un valor menor a -999.99999 en el campo Descuento.',
        max: 'No puede ingresar un valor mayor a 100 en el campo Descuento.'
      },
      minimumQuantityService: {
        required: 'El campo Cantidad Mínima de Servicio es obligatorio.',
        min: 'Debe ingresar un valor igual o superior a Cero (0).',
        max: 'No puede ingresar un valor mayor a 9,999,999.99 en este campo.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formCostCenterPrice.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  resetContract() {
    this.discountValue = 0;
    this.codeNameClient = '';
    this.codeNameConstructionSite = '';
    this.costCenterPriceModel = new CostCenterPriceModel();
    this.validateForm(this.costCenterPriceModel);
  }

  updateDiscountAndUnitValue(baseValue: number, rateDiscount: number, unitValue: number) {
    if (baseValue <= 0) {
      this.discountValue = 0;
      setTimeout(() => {
        this.formCostCenterPrice.patchValue({
          unitValue: unitValue,
          baseUnitValue: baseValue,
          rateDiscount: rateDiscount,
        });
      });
      return;
    }

    let newUnitValue = unitValue;
    if (!unitValue) {
      newUnitValue = Math.round(baseValue * (1 - rateDiscount / 100));
    }

    this.discountValue = (baseValue * Number(rateDiscount.toFixed(5))) / 100;
    setTimeout(() => {
      this.formCostCenterPrice.patchValue({
        baseUnitValue: baseValue,
        unitValue: newUnitValue,
        rateDiscount,
      });
    });
  }

  updateInputs() {
    this.inputsForArticlesSelect$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  updateFormPermision() {
    if (!this.permissionUpdatable || this.blockForm) {
      this.permissionUpdatable = false;
      this.blockForm = true;
      this.formCostCenterPrice.disable();
    }
    const controlsToDisable: string[] = ['rentalUnitId', 'baseUnitValue'];
    if (!this.swFacturacionEspecial) {
      const concept = this.listConcepts.find(x => x.code === 1);
      if (concept?.value) {
        this.formCostCenterPrice.controls['conceptInvoicingId'].setValue(concept.value);
        this.costCenterPriceModel.conceptInvoicingId = concept.value;
        controlsToDisable.push('conceptInvoicingId', 'quantityEspecialInvoicing');
      }
    }
    const swInvoiceUnitM2 = this.formCostCenterPrice.controls['swInvoiceUnitM2'];
    if (this.costCenterPriceModel?.costCenter?.swInvoiceM2) {
      swInvoiceUnitM2.enable();
    } else {
      swInvoiceUnitM2.setValue(false);
      controlsToDisable.push('swInvoiceUnitM2');
    }
    if (this.openFrom !== 'createCostCenterPrice' && this.openFrom !== 'editCostCenterPrice') {
      controlsToDisable.push('branchId', 'costCenterId', 'articleId', 'baseUnitValue',
        'conceptInvoicingId', 'quantityEspecialInvoicing');
    }
    this.formControlStateService.setControlState(this.formCostCenterPrice, controlsToDisable, false);
  }

  validateFormControls() {
    Object.keys(this.formCostCenterPrice.controls).forEach((key) => {
      const control = this.formCostCenterPrice.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }

  validateForm(costCenterPrice: CostCenterPriceModel) {
    this.formCostCenterPrice = this.formBuilder.group({
      branchId: [this.branchIdControl(costCenterPrice), [Validators.required]],
      costCenterId: [costCenterPrice.costCenterId, [Validators.required, Validators.min(1)]],
      conceptInvoicingId: [costCenterPrice.conceptInvoicingId, [Validators.required, Validators.min(1)]],
      quantityEspecialInvoicing: [costCenterPrice.quantityEspecialInvoicing, [Validators.required,
      Validators.min(0), Validators.max(9999999.99)]],
      articleId: [costCenterPrice.articleId, [Validators.required, Validators.min(1)]],
      rentalUnitId: [costCenterPrice?.article?.rentalUnitId],
      swIsInvoiced: [costCenterPrice.swIsInvoiced],
      swInvoiceUnitM2: [costCenterPrice.swInvoiceUnitM2],
      baseUnitValue: [costCenterPrice.baseUnitValue, [Validators.required]],
      unitValue: [costCenterPrice.unitValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      rateDiscount: [costCenterPrice.rateDiscount, [Validators.required, Validators.min(-999.99999),
      Validators.max(100)]],
      minimumQuantityService: [costCenterPrice.minimumQuantityService, [Validators.required, Validators.min(0),
      Validators.max(9999999.99)]]
    });
    this.updateFormPermision();
  }
}
